/* ============================================
   Goldea Hero Slideshow JS
   File: assets/hero-slideshow.js
   ============================================ */

class HeroSlideshow {
  constructor(el) {
    this.el = el;
    this.sectionId = el.dataset.sectionId;
    this.slides = [...el.querySelectorAll('.hero-slideshow__slide')];
    this.dots = [...el.querySelectorAll('.hero-slideshow__dot')];
    this.prevBtn = el.querySelector('.hero-slideshow__arrow--prev');
    this.nextBtn = el.querySelector('.hero-slideshow__arrow--next');

    this.current = 0;
    this.total = this.slides.length;
    this.autoplay = el.dataset.autoplay === 'true';
    this.autoplaySpeed = (parseInt(el.dataset.autoplaySpeed) || 5) * 1000;
    this.timer = null;
    this.isAnimating = false;

    // Touch swipe
    this.touchStartX = 0;
    this.touchEndX = 0;

    if (this.total <= 1) return;

    this.init();
  }

  init() {
    // Dots
    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    // Arrows
    if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
    if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());

    // Touch swipe
    this.el.addEventListener('touchstart', (e) => {
      this.touchStartX = e.changedTouches[0].screenX;
    }, { passive: true });

    this.el.addEventListener('touchend', (e) => {
      this.touchEndX = e.changedTouches[0].screenX;
      this.handleSwipe();
    }, { passive: true });

    // Keyboard
    this.el.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') this.prev();
      if (e.key === 'ArrowRight') this.next();
    });

    // Pause on hover
    this.el.addEventListener('mouseenter', () => this.stopAutoplay());
    this.el.addEventListener('mouseleave', () => this.startAutoplay());

    // Start autoplay
    if (this.autoplay) this.startAutoplay();
  }

  handleSwipe() {
    const diff = this.touchStartX - this.touchEndX;
    if (Math.abs(diff) < 50) return; // Too small, ignore
    if (diff > 0) {
      this.next();
    } else {
      this.prev();
    }
  }

  goTo(index) {
    if (this.isAnimating || index === this.current) return;
    this.isAnimating = true;

    const prev = this.current;
    this.current = (index + this.total) % this.total;

    // Huidige slide naar links schuiven
    this.slides[prev].classList.remove('is-active');
    this.slides[prev].classList.add('is-prev');

    // Nieuwe slide van rechts binnenkomen
    this.slides[this.current].classList.add('is-active');

    // Update dots
    this.dots.forEach((dot, i) => {
      dot.classList.toggle('is-active', i === this.current);
      dot.setAttribute('aria-selected', i === this.current ? 'true' : 'false');
    });

    // Cleanup na transitie
    const speed = parseInt(
      getComputedStyle(this.el).getPropertyValue('--transition-speed') || '600'
    );
    setTimeout(() => {
      this.slides[prev].classList.remove('is-prev');
      this.isAnimating = false;
    }, speed);
  }

  next() {
    this.goTo(this.current + 1);
    this.restartAutoplay();
  }

  prev() {
    this.goTo(this.current - 1);
    this.restartAutoplay();
  }

  startAutoplay() {
    if (!this.autoplay) return;
    this.timer = setInterval(() => this.next(), this.autoplaySpeed);
  }

  stopAutoplay() {
    clearInterval(this.timer);
  }

  restartAutoplay() {
    this.stopAutoplay();
    this.startAutoplay();
  }

  destroy() {
    this.stopAutoplay();
  }
}

// Init all slideshows on page
function initHeroSlideshows() {
  document.querySelectorAll('.hero-slideshow').forEach((el) => {
    if (!el._heroSlideshow) {
      el._heroSlideshow = new HeroSlideshow(el);
    }
  });
}

// Shopify theme editor support
if (window.Shopify?.designMode) {
  document.addEventListener('shopify:section:load', (e) => {
    const section = e.target.querySelector('.hero-slideshow');
    if (section) {
      section._heroSlideshow = new HeroSlideshow(section);
    }
  });

  document.addEventListener('shopify:section:unload', (e) => {
    const section = e.target.querySelector('.hero-slideshow');
    if (section?._heroSlideshow) {
      section._heroSlideshow.destroy();
    }
  });

  document.addEventListener('shopify:block:select', (e) => {
    const slide = e.target;
    const slideshow = slide.closest('.hero-slideshow');
    if (slideshow?._heroSlideshow) {
      const index = parseInt(slide.dataset.index);
      slideshow._heroSlideshow.goTo(index);
      slideshow._heroSlideshow.stopAutoplay();
    }
  });
}

document.addEventListener('DOMContentLoaded', initHeroSlideshows);
